import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTargetOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M16.25 10A6.25 6.25 0 0 1 10 16.25M16.25 10A6.25 6.25 0 0 0 10 3.75M16.25 10h2M10 16.25A6.25 6.25 0 0 1 3.75 10M10 16.25v2M3.75 10A6.25 6.25 0 0 1 10 3.75M3.75 10h-2M10 3.75v-2"
	})]
});
const ForwardRef = forwardRef(SvgTargetOff);
export { ForwardRef as ReactComponent };
